import { v4 as uuidv4 } from 'uuid';

const withId = (o) => (o && typeof o === 'object' ? { ...o, id: o.id || uuidv4() } : o);

/**
 * Ensure every section, attribute, option, and table column carries a stable
 * uuid `id`. Version history matches everything by id, so this runs on form
 * load. Idempotent — existing ids are preserved, only missing ones are filled.
 */
export const ensureFormIds = (form) => {
    if (!form || typeof form !== 'object') return form;

    const sections = (form.sections || []).map((section) => {
        const s = withId(section);
        s.attributes = (s.attributes || []).map((attr) => {
            const a = withId(attr);
            if (a.properties && typeof a.properties === 'object') {
                const p = { ...a.properties };
                if (Array.isArray(p.options)) p.options = p.options.map(withId);
                if (p.table && Array.isArray(p.table.tableHead)) {
                    p.table = { ...p.table, tableHead: p.table.tableHead.map(withId) };
                }
                a.properties = p;
            }
            return a;
        });
        return s;
    });

    return { ...form, sections };
};
